import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "58pt",
  height: "24",
  viewBox: "0 0 58 58"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M56.848 22.242c-.77-.765-1.707-1.152-2.805-1.152H3.953c-1.098 0-2.031.387-2.8 1.152Q-.002 23.396 0 25.043v7.91q0 1.653 1.152 2.8 1.154 1.154 2.801 1.153h50.09c1.098 0 2.035-.383 2.8-1.152Q58 34.604 58 32.954v-7.911c0-1.098-.387-2.031-1.152-2.8m0 0",
      style: {"stroke":"none","fill-rule":"nonzero","fill":"#000","fill-opacity":"1"}
    }, null, -1)
  ]))]))
}
export default { render: render }